var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingSection4Card1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#FEBA05",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1127 7.78745L11.8752 10.1249C10.4377 10.6624 9.2627 12.3624 9.2627 13.8999V23.1874C9.2627 24.6624 10.2377 26.5999 11.4252 27.4874L16.8002 31.5C18.5627 32.825 21.4627 32.825 23.2252 31.5L28.6002 27.4874C29.7877 26.5999 30.7627 24.6624 30.7627 23.1874V13.8999C30.7627 12.3624 29.5877 10.6624 28.1502 10.1249L21.9127 7.78745C20.8502 7.39995 19.1502 7.39995 18.1127 7.78745Z",
    stroke: "#FEBA05",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 18.65C19.9496 18.65 19.8871 18.65 19.8371 18.65C18.6621 18.6125 17.7246 17.6375 17.7246 16.45C17.7246 15.2375 18.7121 14.25 19.9246 14.25C21.1371 14.25 22.1246 15.2375 22.1246 16.45C22.1121 17.65 21.1746 18.6125 19.9996 18.65Z",
    stroke: "#FEBA05",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5123 22.15C16.3123 22.95 16.3123 24.2624 17.5123 25.0624C18.8748 25.9749 21.1123 25.9749 22.4748 25.0624C23.6748 24.2624 23.6748 22.95 22.4748 22.15C21.1248 21.2375 18.8873 21.2375 17.5123 22.15Z",
    stroke: "#FEBA05",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingSection4Card1);
export default __webpack_public_path__ + "static/media/landing_section4_card1.de0685f7259b4138bd65bc43e423503b.svg";
export { ForwardRef as ReactComponent };